import styled from 'styled-components';


interface BtnSearchProps {
  color?: string;
}
export const Container = styled.div`
  display: flex;
  margin: 2rem 0 0 0;
  height: fit-content;
  justify-content: center;

  @media (max-width: 820px) {
    margin: 2rem 0 0 1.5rem;
    justify-content: flex-start;
  }
`;

export const WrapperContent = styled.div`
  margin-left: 1rem;
  width: min(1190px, 100%);
  
  @media (max-width: 820px) {
    width: 97%;
    margin-left: 0;
  }

  @media (max-width: 409px) {
    width: 85%;
    margin-left: 1rem;
  }
`;
export const  Bg = styled.div<BtnSearchProps>`
width: 35px;
height: 35px;
display: flex;
justify-content: center;
align-items: center;
  background-color: ${props => props.color};
  /* svg{
    width: 40px;
    height: 40px;
  } */
  
`
export const TitleSection = styled.b`
  font-size: 1rem;
  color: var(--color-title-sectoin);
  background-color: red;
`;

export const WrapperCard = styled.div`
  display: flex;
  padding-top: 1rem;
  justify-content: space-between;

  @media (max-width: 820px) {
    align-items: center;
    flex-direction: column;
  }
`;
export const BtnSearch = styled.div<BtnSearchProps>`

width: 208px;
height: 35px;
/* UI Properties */
background: ${props => props.color ? props.color : 'black'} 0% 0% no-repeat padding-box;
border-radius: 22px;
opacity: 1;
display: flex;
justify-content: center;
align-items: center;
p{
  margin: 0;
  font: normal normal 600 12px/16px Poppins;
  letter-spacing: 0.6px;
  color: #FFFFFF !important;
  }
&:hover{
  background-color:${props => props.color ? props.color : 'black'}4d;
  cursor: pointer;
}
`

export const TitleBox = styled.div`
width: 100%;
height: 50px;
background: #E7E7E7 0% 0% no-repeat padding-box;
display: flex;
align-items: center;
justify-content: space-between;
padding: 8px;
p{
  font: normal normal medium 16px/19px Poppins;
  letter-spacing: 0px;
  color: #161615;
  margin-left: 10px;
  font-weight: 600;
}

.wrapper{
  display: flex;
  align-items: center;
}
`

export const ConainerMain = styled.div`
grid-area: AreaVariationBest;
display: flex;
flex-direction: column;
margin-bottom: 5%;
@media (max-width: 820px) {
  display: none;
}

.teste{
  width: min(1190px, 100%);
  align-self: center;
  margin-left: 1rem;
  margin-top: 44px;
}
`